export default "__VITE_ASSET__821acac3__"